import { createApp } from 'vue'
import Cookies from 'js-cookie'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn' // 引入中文语言包
import 'element-plus/dist/index.css';

import i18n from "./lang/index.js";//本地化语言
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive
import plugins from './plugins' // plugins

import '@/permission' // permission control
import '@/assets/styles/index.scss' // global css
import '@/assets/iconfont/iconfont.css'

// svg图标
import 'virtual:svg-icons-register'

import SvgIcon from '@/components/SvgIcon'
// SvgIcon
import elementIcons from '@/components/SvgIcon/svgicon'
// 分页组件
import Pagination from '@/components/Pagination'
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'

// 自定义树选择组件
import TreeSelect from '@/components/TreeSelect'
// 引入滚动条组件v3scroll
//import V3Scroll from '@/components/V3Scroll'

// 拖拽上传组件
import DragUpload from "@/components/Upload/DragUpload"
// 文件上传组件
import FileUpload from "@/components/Upload/FileUpload"
// 图片预览组件
import ImagePreview from "@/components/Upload/ImagePreview"
// 普通图片上传组件
import ImageUpload from "@/components/Upload/ImageUpload"
// 导入上传组件
import ImportUpload from "@/components/Upload/ImportUpload"
// 输入文件上传组件
import InputUpload from "@/components/Upload/InputUpload"
// 可裁剪的上传组件
import CropperUpload from "@/components/Upload/CropperUpload"
// 多图片上传组件
import MultiUpload from "@/components/Upload/MultiUpload"
// 文件读取组件
import ReadUpload from "@/components/Upload/ReadUpload"
// 图片选择或上传组件
import SelectUpload from "@/components/Upload/SelectUpload"
// 单图文件上传组件
import SingleUpload from "@/components/Upload/SingleUpload"
// 提交上传组件
import SubmitUpload from "@/components/Upload/SubmitUpload"
// 视频上传组件
import VideoUpload from "@/components/Upload/VideoUpload"

// 对于开发环境显示完整 hydration 错误信息
// if (import.meta.env.DEV) {
//   __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true
// }

const app = createApp(App)

// 全局组件挂载
app.component('Pagination', Pagination)
app.component('RightToolbar', RightToolbar)
app.component('TreeSelect', TreeSelect)

app.component('DragUpload', DragUpload)
app.component('FileUpload', FileUpload)
app.component('ImagePreview', ImagePreview)
app.component('ImageUpload', ImageUpload)
app.component('ImportUpload', ImportUpload)
app.component('InputUpload', InputUpload)
app.component('CropperUpload', CropperUpload)
app.component('MultiUpload', MultiUpload)
app.component('ReadUpload', ReadUpload)
app.component('SelectUpload', SelectUpload)
app.component('SingleUpload', SingleUpload)
app.component('SubmitUpload', SubmitUpload)
app.component('VideoUpload', VideoUpload)

app.use(router)
app.use(store)
app.use(plugins)
app.use(elementIcons)
app.use(i18n)
//app.use(V3Scroll)
app.component('svg-icon', SvgIcon)

directive(app)
// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  locale: zhCn, // 设置语言为中文
  // 支持 large、default、small
  size: Cookies.get('size') || 'default'
})
app.mount('#app')